<template>
    <ModalBase :show-modal="showModal" @close-modal="close">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal">
                <template v-slot:title>
                    {{ $gettext('Invoice') }} <span v-if="invoice">{{ invoice.number }}</span>
                </template>
            </TitleBar>
        </template>
        <template v-slot:maincontent>
            <VueDropzone v-show="invoiceUrl" :preloaded_file="invoiceUrl" :allowed-files="'all'" :disableEdit="true" :disableRemove="true"></VueDropzone>
        </template>
    </ModalBase>
</template>

<script>
import TitleBar from "@/components/TitleBar"
import ModalBase from "@/components/base_components/ModalBase"
import VueDropzone from "@/components/VueDropzone"

export default {
    name: "SimpleInvoiceModal",
    components: {TitleBar, ModalBase, VueDropzone},
    props: {
        invoice: {
            type: Object,
            default: () => null
        }
    },
    watch: {
        invoice(val) {
            if (val) {
                this.show()
                setTimeout(() => {this.invoiceUrl = val.pdf_file}, 100)
            } else {
                this.close()
            }
        }
    },
    data() {
        return {
            showModal: false,
            invoiceUrl: ''
        }
    },
    methods: {
        show() {
            this.showModal = true
        },
        close() {
            this.invoiceUrl = ''
            this.showModal = false
            this.$emit('close')
        }
    }
}
</script>